<template>
  <div class="main-wrap">
    <abnormal v-if="errorMsg" :error="errorMsg" />
    <index
      v-else-if="initLandingPage === true"
      :position="position"
      @onPageError="handleActivityError"
    ></index>
    <loading-mask v-show="loading"></loading-mask>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Popup, Scroll, Dialog, Locale } from '@didi/rich-ui'
  import trackEvent from '@/page/landingpage/track'
  import { setTitle } from '@/common/js/bridge'
  import LoadingMask from '@/components/loading/loading-mask'
  import { getLanguageLong } from '@didi/gettext'
  import { mapActions, mapGetters } from 'vuex'
  Vue.use(Popup)
  Vue.use(Scroll)
  Vue.use(Dialog)
  Vue.use(Locale)
  const currentLang = getLanguageLong()
  Locale.use(currentLang, require(`@didi/rich-ui/lib/locale/lang/${currentLang}`))
  export default {
    name: 'LandinpageDefault',
    components: {
      LoadingMask,
      Abnormal: () => import('./abnormal'),
      Index: () => import('./index')
    },
    data () {
      return {
        errorMsg: '',
        initLandingPage: false,
        position: {},
        loading: false
      }
    },
    created () {
      const { country } = this.$store.state
      const title = GlobalConfig[country].title
      this.params.title? setTitle(decodeURIComponent(this.params.title)): setTitle(title)
    },
    async mounted () {
      this.loading = true
      await this.getGlobalParams()
      // 获取端内、端外定位
      if (this.isApp) {
        await this.getInitAppData()
      } else {
        await this.getInitOutData()
      }
      this.loading = false
    },
    computed: {
      ...mapGetters(['globalParams'])
    },
    methods: {
      ...mapActions({
        getGlobalParams: 'getGlobalParams'
      }),
      async getInitAppData () {
        // 优先从globalParams中获取，其次从bridge方法getLocationInfo里获取定位经纬度
        if (this.globalParams.data.poiLat && this.globalParams.data.poiLng) {
          this.position = {
            lat: +this.globalParams.data.poiLat,
            lng: +this.globalParams.data.poiLng,
            city_id: +this.globalParams.data.poiCityId
          }
          this.initLandingPage = true
        } else {
          const locationInfo = await this.SodaBridge('getLocationInfo')

          if (locationInfo && +locationInfo.errno === 1) {
            this.handleLocationError(locationInfo.data)
          } else {
            this.position = locationInfo.data
            this.initLandingPage = true
          }
        }
      },
      async getInitOutData () {
        // 端外打开场景直接获取定位地址
        Soda.getLocationInfo({}, async (data) => {
          if (data && +data.errno === 1) {
            // this.handleLocationError(data)
          } else {
            this.position = {
              lat: data.lat,
              lng: data.lng,
              city_id: 0
            }
          }
          this.initLandingPage = true
        })
      },
      handleLocationError (data) {
        if (data && +data.errno === 1) {
          this.$createDialog({
            type: 'alert',
            icon: 'richic-important',
            title: this.gettext('请开启定位'),
            content: this.gettext('定位服务未开启，需要先开启定位服务才能参与活动！'),
            showClose: true,
            confirmBtn: {
              text: this.gettext('我知道了'),
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            onConfirm: () => {
              trackEvent.call(this, {
                eventId: 'sailing_c_x_activitylocate_window_ck',
                eventLabel: '拉新活动进入定位询问点击',
                attrs: {
                  selected: 1
                }
              })
            }
          }).show()
          trackEvent.call(this, {
            eventId: 'sailing_c_x_activitylocate_window_sw',
            eventLabel: '拉新活动进入定位询问展示'
          })
        } else {
          this.$createDialog({
            type: 'alert',
            content: this.gettext('网络似乎存在问题，请稍后重试'),
            icon: 'richic-important',
            confirmBtn: {
              text: this.gettext('我知道了'),
              active: false,
              href: 'javascript:;'
            }
          }).show()
        }
        this.errorMsg = this.gettext('此活动尚未在您的城市开通')
      },
      handleActivityError (errorMsg) {
        this.errorMsg = errorMsg
        this.initLandingPage = false
      }
    }
  }
</script>
<style lang="scss">
@import "~@/assets/styles/var.scss";
.rich-dialog-btn, .rich-dialog-btn_highlight{
  @include rich-dialog-btn-color();
}
@media screen and (min-width: 1024px) {
  html {
    font-size: 48PX !important;
    max-width: 1024px;
    margin: auto;
  }
}
</style>
